"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
var react_2 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var CustomLabel_1 = require("./CustomLabel");
require("./TextFieldLink.scss");
exports.TextFieldLink = function (props) {
    var label = props.label, value = props.value, url = props.url, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, maxWidth = props.maxWidth;
    return (react_2.default.createElement("div", null,
        react_2.default.createElement(CustomLabel_1.Label, { toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label),
        react_2.default.createElement("div", { style: maxWidth ? { maxWidth: maxWidth } : undefined, className: clsx_1.default('eta-textFieldLink', maxWidth ? 'addEllipsis' : undefined) },
            react_2.default.createElement(react_router_dom_1.NavLink, { exact: true, title: value, to: url, target: '_blank' }, value),
            "\u00A0",
            react_2.default.createElement(react_1.Icon, { iconName: 'NavigateExternalInline', className: 'navLinkIcon' }))));
};
//# sourceMappingURL=TextFieldLink.js.map